import { combineReducers } from "redux";
import Setting from "./settings";
const createReducer = (asyncReducers) =>
  combineReducers({
    ...asyncReducers,
    Setting,
  });

export default createReducer;
